import { Box, Typography } from '@mui/material'
import FigmaIconFrame from '../common/FigmaIconFrame'

export default function ProgramSkillCard({ title, description, iconSrc, iconBgColor, iconBoxSize = 64, iconInnerSize = 48 }) {
  return (
    <Box
      sx={{
        bgcolor: '#fffefa',
        borderRadius: '20px',
        boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
        p: '24px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '50px',
          height: '100%',
        }}
      >
        <FigmaIconFrame
          src={iconSrc}
          bgColor={iconBgColor}
          boxSize={iconBoxSize}
          innerSize={iconInnerSize}
        />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Typography
            sx={{
              fontSize: { xs: 24, md: 28 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 18, md: 20 },
              lineHeight: '24px',
              fontWeight: 400,
              color: 'rgba(17,17,17,0.6)',
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
